module.exports = __webpack_public_path__ + "icon_done-e07ea253e82d137816cfb8d77a3b1562.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_done.png
// module id = 272
// module chunks = 88